import { render, staticRenderFns } from "./AvatarWidget.vue?vue&type=template&id=4d355a96&"
import script from "./AvatarWidget.vue?vue&type=script&lang=js&"
export * from "./AvatarWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports